import CorrectingPage from './CorrectingPage';
export default CorrectingPage;
